/**
 * Marketing homepage for an explicit Product click.
 * `/` itself sends a signed-in visitor to the Hub.
 */
export const PRODUCT_OVERVIEW_PATH = "/product";

/** Terminal pages anonymous users may open from Hub widgets and CTAs. */
export const HUB_PUBLIC_NAV_PREFIXES = [
  "/radar",
  "/portfolios",
  "/heatmap",
  "/headlines",
  "/watchtower",
  "/watchlist",
  "/hub",
  "/reports",
  "/ai-server-stocks",
] as const;

/** True when an anonymous Hub visitor may follow this link without signing in. */
export function isHubPublicNavLink(href: string | null | undefined): boolean {
  if (!href) return false;
  if (href.startsWith("http")) return true;
  if (href.startsWith("#")) return true;
  if (
    href === "/" ||
    href === "/subscription" ||
    href === "/landing" ||
    href === PRODUCT_OVERVIEW_PATH
  ) {
    return true;
  }

  const path = href.split("?")[0].split("#")[0];
  return HUB_PUBLIC_NAV_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
